/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module EmailValidationModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { SharedModule } from 'ng/shared/shared.module';
import { EmailValidationModalComponent } from './email-validation-modal.component';
import { EmailValidationService } from './email-validation-modal.service';

@NgModule({
    declarations: [
        EmailValidationModalComponent,
    ],
    imports: [
        AviFormsModule,
        SharedModule,
    ],
    providers: [
        EmailValidationService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class EmailValidationModule {}
